import { render, staticRenderFns } from "./ResumoEstoqueUnidades.vue?vue&type=template&id=84e4f0c0&scoped=true"
import script from "./ResumoEstoqueUnidades.vue?vue&type=script&lang=js"
export * from "./ResumoEstoqueUnidades.vue?vue&type=script&lang=js"
import style0 from "./ResumoEstoqueUnidades.vue?vue&type=style&index=0&id=84e4f0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e4f0c0",
  null
  
)

export default component.exports